import {Fragment} from 'react';
// @ts-expect-error @headlessui/react incompatibility with node16 resolution
import {Dialog, Transition} from '@headlessui/react';
import {Customer} from '@shopify/hydrogen/storefront-api-types';
import {Image, Link} from '@shopify/hydrogen';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  menu: {
    title: string;
    to: string;
  }[];
  customer: Customer;
};

export function NewMenuDrawer({isOpen, onClose, menu, customer}: Props) {
  const styles = {
    button_cta: 'text-white bg-acai-900 py-4 px-9 text-sm rounded-full',
  };

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-20" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center text-center">
            <Transition.Child
              as={Fragment}
              enter="transition ease-in-out duration-300 transform"
              enterFrom="-translate-x-full"
              enterTo="translate-x-0"
              leave="transition ease-in-out duration-300 transform"
              leaveFrom="translate-x-0"
              leaveTo="-translate-x-full"
            >
              <Dialog.Panel className="h-screen w-screen transform overflow-hidden bg-foam-100 pt-[169px] transition-all">
                <div className="flex h-full flex-col items-start gap-5 px-10 pt-10 md:flex-row md:items-center md:justify-between md:px-20">
                  <div className="flex flex-col items-start gap-y-6 md:basis-2/5 md:gap-y-10">
                    <div className="flex flex-col items-start">
                      {menu.map((item) => (
                        <Link key={item.to} to={item.to} onClick={onClose}>
                          <span className="text-2xl text-acai-900 hover:opacity-70 md:text-[42px] md:leading-tight">
                            {item.title}
                          </span>
                        </Link>
                      ))}
                    </div>
                    {customer ? (
                      <Link
                        className="hover:opacity-70"
                        to="/account"
                        onClick={onClose}
                      >
                        <button className={styles.button_cta}>Profile</button>
                      </Link>
                    ) : (
                      <Link
                        className="hover:opacity-70"
                        to="/account/login"
                        onClick={onClose}
                      >
                        <button className={styles.button_cta}>Sign In</button>
                      </Link>
                    )}
                  </div>
                  <Link
                    to="/products/gift-a-refresh"
                    className="md:basis-3/5"
                    onClick={onClose}
                  >
                    <div className="flex w-full justify-center md:justify-end">
                      <Image
                        alt="menu-image"
                        src="/images/header-hero.webp"
                        width="auto"
                        height="auto"
                        className="w-3/4 sm:w-3/5 md:w-full"
                        sizes="(min-width: 640px) 60vw, 70vw"
                      />
                    </div>
                  </Link>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
